import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { forkJoin } from 'rxjs/internal/observable/forkJoin';
import { ToastrHelper } from '../../../helpers/toastr.helper';
import { CommunityFilter } from '../../../models/identity/community-filter.model';
import { FiltersItem } from '../../../models/shared/filters-item.model';
import { CommunityService } from '../../../services/identity/community.service';
import { CommunityWithRoles } from './../../../models/identity/community-with-roles.model';

@Component({
    selector: 'app-communities-filters-dropdown',
    templateUrl: './communities-filters-dropdown.component.html',
})
export class CommunitiesFiltersDropdownComponent implements OnInit {
    @Input() clearAllSelection: boolean;
    @Input() projectsDirectory: boolean;

    @Output() ready = new EventEmitter();
    @Output() selectionChanged = new EventEmitter();
    @Output() checkAllSelectionChanged = new EventEmitter<boolean>();

    private userCommunities: CommunityWithRoles[];
    userCommunitiesFilterItems: FiltersItem[];

    constructor(private readonly communityService: CommunityService, private readonly toastrHelper: ToastrHelper) {}

    ngOnInit(): void {
        this.loadCommunities();
    }

    loadCommunities() {
        forkJoin([this.communityService.getCommunities(), this.communityService.getMyCommunities()]).subscribe(
            ([allCommunities, userCommunities]) => {
                this.userCommunities = userCommunities;

                const primaryCommunityIndex = this.userCommunities.findIndex((community) => community.isPrimary);

                const primaryCommunity = this.userCommunities.splice(primaryCommunityIndex, 1);
                this.userCommunities.splice(0, 0, primaryCommunity[0]);

                this.userCommunitiesFilterItems = this.userCommunities.map((community) => {
                    return new FiltersItem(
                        community.id,
                        community.displayName,
                        community.communitiesGroups
                            ? allCommunities
                                  .find((c) => c.id === community.id)
                                  .communitiesGroups.map((group) => new FiltersItem(group.id, group.displayName))
                            : null,
                    );
                });

                this.ready.emit();
            },
            (error) => {
                this.toastrHelper.showGenericError(error);
            },
        );
    }

    setSelectedFilters(communityFilters: CommunityFilter[]) {
        communityFilters.forEach((communityFilter) => {
            const associatedFilterItem = this.userCommunitiesFilterItems.find((filter) => filter.key === communityFilter.id);
            associatedFilterItem.checked = true;

            if (communityFilter.groupsIds) {
                communityFilter.groupsIds.forEach((groupId) => {
                    associatedFilterItem.groups.find((filter) => filter.key === groupId).checked = true;
                });
            }
        });
    }

    setSelectedFiltersWithIds(communitiesIds: string[]) {
        this.userCommunitiesFilterItems.forEach((item) => (communitiesIds.includes(item.key) ? item.check() : item.uncheck()));
    }

    onCommunitiesSelectionChanged() {
        this.selectionChanged.emit();
    }

    onAllMyCommunitiesSelectionChanged(allChecked: boolean) {
        this.checkAllSelectionChanged.emit(allChecked);
    }

    resetFilters(selectMainCommunity: boolean = false): void {
        this.userCommunitiesFilterItems.forEach((item) => item.uncheck());

        if (selectMainCommunity) {
            const primaryCommunityFilter = this.userCommunitiesFilterItems.find(
                (community) => community.key === this.userCommunities.find((userCommunity) => userCommunity.isPrimary).id,
            );

            primaryCommunityFilter.check();
        }
    }
}
